(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@lokidb/loki", [], factory);
	else if(typeof exports === 'object')
		exports["@lokidb/loki"] = factory();
	else
		root["@lokidb/loki"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 